module.exports = __webpack_public_path__ + "img/Group243.ddca3c8e.svg";